/*
saikrishna 11/03/2022 3075154998 changed the paginationOptions
 */
import React, {createRef} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../../components/TableIcons';
import GuiTable from '../../../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../../../constants/ReusableTablePagination';

export default function ActionTable({
  actionData,
  setActionData,
  setActionRowData,
  setIsEditMode,
  setActionCode,
  deleteAction,
  setDeleteAction,
}) {
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        actionData[rowData.tableData.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Action Type',
      field: 'type',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Parameter(s)',
      field: 'parameters',
      headerStyle: {
        textAlign: 'left',
      },
      minWidth: '400px',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: '350px',
              whiteSpace: 'normal',
            }}
          >
            `$
            {(rowData?.toField?.length > 0 && rowData?.sourceField?.length > 0) ||
            (rowData?.toField?.length > 0 && rowData?.format?.length > 0) ||
            (rowData?.toField?.length > 0 && rowData?.expression?.length > 0) ?
              rowData?.toField?.concat(',') :
              rowData?.toField?.length > 0 ?
                rowData?.toField :
                ''}{' '}
            $
            {(rowData?.sourceField?.length > 0 && rowData?.format?.length > 0) ||
            (rowData?.sourceField?.length > 0 && rowData?.expression?.length > 0) ?
              rowData?.sourceField?.concat(',') :
              rowData?.sourceField?.length > 0 ?
                rowData?.sourceField :
                ''}{' '}
            $
            {rowData?.format?.length > 0 && rowData?.expression?.length > 0 ?
              rowData?.format?.concat(',') :
              rowData?.format?.length > 0 ?
                rowData?.format :
                ''}{' '}
            ${rowData?.expression?.length > 0 ? rowData?.expression : ''} $
            {rowData?.disposition?.value === undefined ? '' : rowData?.disposition?.value}`
          </div>
        </>
      ),
    },
  ];

  const tableRef = createRef();

  const tableDataAction = actionData ?
    actionData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];

  return (
    <div className="global-field-table custom-table">
      <GuiTable
        title=""
        columns={columns}
        icons={tableIcons}
        tableRef={tableRef}
        data={tableDataAction}
        options={{
          search: false,
          toolbar: false,
          pageSize: defaultRows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
      />
    </div>
  );
}
